
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const storeApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listStores: builder.query ({
      query: (params) => `v2/store/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Store"]
    }),
    getStore: builder.query ({
      query: (store_id) => `v2/store/${store_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Store"]
    }),

    updateStore: builder.mutation ({
      query: ({store_id, data}) => ({
        url: `v2/store/${store_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Store"]
    }),
    deleteStore: builder.mutation ({
      query: (store_id) => ({
        url: `v2/store/${store_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Store"]
    }),
    createStore: builder.mutation ({
      query: (data) => ({
        url: `v2/store/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Store"]
    }),
  })
})


export const {
  useListStoresQuery,
  useLazyListStoresQuery,
  useGetStoreQuery,
  useLazyGetStoreQuery,

  useUpdateStoreMutation,
  useDeleteStoreMutation,
  useCreateStoreMutation
} = storeApi
